import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = ({ allowedRoles = [], children }) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  const rolesFromUser = user?.roles || [];
  const effectiveRole =
    role || (rolesFromUser.includes("admin") ? "admin" : rolesFromUser.length ? "customer" : null);

  const isAllowed = user && (allowedRoles.length === 0 || allowedRoles.includes(effectiveRole));

  if (!isAllowed) {
    return <Navigate to="/admin-login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
